// @flow

import React from 'react';

import {DetailPageGenericPoliciesSidebar} from 'app/components/general/DetailPageGenericPoliciesSidebar';
import type {RelatedPolicyType} from 'app/policies/types';

type Props = {|
  processId: number,
  processURL: string,
  showFilterField: boolean,
  loadItems: () => Promise<any>,
  canEdit: boolean,
  items: Array<RelatedPolicyType>,
  onClose: () => void,
|};

export const ProcessPolicieSidebar = ({
  processURL,
  processId,
  loadItems,
  showFilterField,
  ...other
}: Props) => {
  const props = {
    objectId: processId,
    objectURL: processURL,
    contentType: 'proceduregroup',
    loadItems,
    showFilterField,
    ...other,
  };

  return <DetailPageGenericPoliciesSidebar {...props} />;
};
